import React, { FC, useState } from 'react';

import FormField from 'common/components/base/form-field';
import Input from 'common/components/base/input';
import Label from 'common/components/base/label';
import { WhatsNewField, InputType } from 'common/enums';
import { FieldError, FileDetails } from 'common/models';
import FieldErrorList from '../../field-error-list/FieldErrorList';
import FileUploader from 'common/components/base/file-upload';
import { FILE_COUNT_MAX } from 'common/config';
import {
    WhatsNewLinkFieldType,
    WhatsNewLinkType
} from 'modules/configuration/enums/configuration.enum';
import Icon from 'common/components/base/icon';
import { ICON_COLLECTION } from 'assets/media/icons';
import WhatsNewLinkModal from 'modules/configuration/components/whats-new-link-modal/WhatsNewLinkModal';

type VideoImageFormProps = {
    fieldErrors: Array<FieldError>;
    handleNameChange: (event: any) => void;
    handleSortOrderChange: (value: string) => void;
    handleDescription: (event: any) => void;
    name: string;
    sortOrder: string;
    description: string;
    uploadingFiles: Array<FileDetails>;
    selectedFiles: Array<FileDetails>;
    errorMessage: string;
    onDrop: (files: Array<FileDetails>) => void;
    onSelectedFileRemove: (file: FileDetails) => void;
    radioButtonSelected: string;
    isEditMode: boolean;
    fileName: string;
    removeExistingFile: () => void;
};

const VideoImageForm: FC<VideoImageFormProps> = ({
    fieldErrors,
    name,
    handleNameChange,
    sortOrder,
    handleSortOrderChange,
    description,
    handleDescription,
    uploadingFiles,
    selectedFiles,
    errorMessage,
    onDrop,
    onSelectedFileRemove,
    radioButtonSelected,
    isEditMode,
    fileName,
    removeExistingFile
}) => {
    const [showLinkModal, setShowLinkModal] = useState<boolean>(false);
    const [linkModalData, setLinkModalData] = useState<any>(null);

    const setModalData = () => {
        setLinkModalData({
            link: fileName,
            whatsNewTypeId:
                radioButtonSelected === WhatsNewLinkFieldType.Video
                    ? WhatsNewLinkType.Video
                    : WhatsNewLinkType.Image
        });
        setShowLinkModal(true);
    };
    const closeLinkModal = () => {
        setLinkModalData({});
        setShowLinkModal(false);
    };
    const fileUploader = () => {
        return (
            <FileUploader
                maxFiles={FILE_COUNT_MAX}
                uploadingFiles={uploadingFiles}
                selectedFiles={selectedFiles}
                errorMessage={errorMessage}
                onSelectedFileRemove={onSelectedFileRemove}
                onDrop={onDrop}
                uploadText={`Drag and drop an ${
                    radioButtonSelected === 'video' ? 'video' : 'image'
                } or browse`}
            />
        );
    };

    const fileList = () => {
        return (
            <div className="whats-new-edit-file-list">
                <span>
                    {radioButtonSelected === WhatsNewLinkFieldType.Video
                        ? `${WhatsNewLinkFieldType.Video}`
                        : `${WhatsNewLinkFieldType.Image}`}{' '}
                    file
                </span>
                <div>
                    <Icon src={ICON_COLLECTION.IC_Delete} onClick={removeExistingFile} />
                    <Icon src={ICON_COLLECTION.IC_Info} onClick={setModalData} />
                </div>
            </div>
        );
    };
    return (
        <>
            <div className="whats-new-section">
                <span className="info">
                    {' '}
                    Fill in the below details and upload the{' '}
                    {`${radioButtonSelected === 'video' ? 'video' : 'image'}`}:{' '}
                </span>
                <div className="whats-new-section-form">
                    <FormField className="whats-new-form-field">
                        <Label text="Name (required)"></Label>
                        <Input
                            type={InputType.TEXT}
                            value={name ?? ''}
                            onChange={handleNameChange}
                        />
                        <FieldErrorList field={WhatsNewField.Name} errors={fieldErrors} />
                    </FormField>

                    <FormField className="whats-new-form-field-desc">
                        <Label text="Small description"></Label>
                        <Input
                            type={InputType.TEXT}
                            value={description ?? ''}
                            onChange={handleDescription}
                        />
                        <FieldErrorList
                            field={WhatsNewField.Description}
                            errors={fieldErrors}
                            data-testid="error"
                        />
                    </FormField>
                </div>

                <div className="whats-new-form-file-upload">
                    <span className="whats-new-form-file-upload-text">
                        {isEditMode && fileName ? 'uploaded' : 'Upload'}{' '}
                        {`${radioButtonSelected === 'video' ? 'video' : 'image'}`}:{' '}
                    </span>
                    {isEditMode && fileName ? fileList() : fileUploader()}
                    <FieldErrorList
                        field={`${
                            radioButtonSelected === 'video'
                                ? WhatsNewField.Video
                                : WhatsNewField.Image
                        }`}
                        errors={fieldErrors}
                    />
                </div>
            </div>

            {showLinkModal && (
                <WhatsNewLinkModal
                    show={showLinkModal}
                    data={linkModalData}
                    onClose={closeLinkModal}
                />
            )}
        </>
    );
};

export default VideoImageForm;
